export class ModuleLibraryVersion {
  constructor(
    public name: string,
    public description: string,
    public version: string,
    public created: Date,
    public updated: Date
  ) {}
}
